import styled from "styled-components"


const OraclePanel = styled.div`

    color: ${({ theme }) => theme.panelTextColor};
    background-color: ${({ theme }) => theme.panelBackgroundColor};
    border: 0.2em solid ${({ theme }) => theme.panelBorderColor};

	box-shadow: ${({ theme }) => theme.panelShadow};

	border-radius: 1.75em;
	font-size: 0.75rem;
	justify-content: space-between;
	margin-top: 1em;
	margin-bottom: 0em;
	overflow: hidden;
	padding: 0.2rem;
	padding-bottom: 0.7rem;
	outline: none;
	font-weight: normal;
	text-decoration: none;
	text-align: left;

	display: flex;
    flex-direction: column;
    justify-content: space-between;
    max-width: 90vw;

	/* Tablets */
	@media (max-width: 1400px) {
			font-size: 0.85rem;
	}

	/* Mobiles */
	@media (max-width: 640px) {
		font-size: 0.85rem;
		width: 90vw;
	}
`;

export default OraclePanel;